import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import Switch from "react-switch";
import { LiaTimesSolid } from "react-icons/lia";
import { motion } from "framer-motion";
import { AttentionSeeker } from "react-awesome-reveal";

const Cookies = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [shake, setShake] = useState(false);
  const [cookiesConfig, setCookiesConfig] = useState({
    essential: true, // Always enabled
    marketing: false,
    functional: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowPopup(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", JSON.stringify(cookiesConfig));
    setShowPopup(false);
  };

  const handleDecline = () => {
    setCookiesConfig({
      essential: true,
      marketing: false,
      functional: false,
    });
    localStorage.setItem("cookieConsent", JSON.stringify(cookiesConfig));
    setShowPopup(false);
  };

  const toggleSetting = (type) => {
    setCookiesConfig((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handleSaveSettings = () => {
    localStorage.setItem("cookieConsent", JSON.stringify(cookiesConfig));
    setShowSettings(false);
    setShowPopup(false);
  };

  const resetConsent = () => {
    localStorage.removeItem("cookieConsent");
    setShowPopup(true);
  };

  const handleInteractionAttempt = (e) => {
    if (showPopup && !shake) {
      setShake(true);
      setTimeout(() => setShake(false), 200);
    }
  };

  useEffect(() => {
    if (showPopup) {
      document.addEventListener("click", handleInteractionAttempt);
      document.addEventListener("scroll", handleInteractionAttempt);
      document.addEventListener("keydown", handleInteractionAttempt);
      return () => {
        document.removeEventListener("click", handleInteractionAttempt);
        document.removeEventListener("scroll", handleInteractionAttempt);
        document.removeEventListener("keydown", handleInteractionAttempt);
      };
    }
  }, [showPopup]);

  if (!showPopup) return null;

  return (
    <>
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 100, damping: 20 }}
        className="fixed inset-0 flex items-center justify-center p-6 z-50"
      >
        <AttentionSeeker
          effect={shake ? "shake" : undefined}
          triggerOnce={false}
          duration={500}
        >
          <div className="relative bg-navBg p-6 rounded-lg w-full max-w-md">
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-2 right-2 text-2xl text-white"
            >
              <LiaTimesSolid />
            </button>
            <h1 className="text-white mb-4  text-xl">
              We use cookies on our website to see how you interact with it. By
              accepting, you agree to our use of such cookies.
            </h1>
            <div className="flex justify-around space-x-4">
              <button
                onClick={handleAccept}
                className="bg-white h-12 px-6 text-navBg w-full"
              >
                Accept
              </button>
              <button
                onClick={handleDecline}
                className="bg-transparent border-2 border-white text-white px-6 w-full"
              >
                Decline All
              </button>
            </div>
            <p
              onClick={() => setShowSettings(true)}
              className="text-white text-center underline mt-4 cursor-pointer"
            >
              Settings
            </p>
          </div>
        </AttentionSeeker>
      </motion.div>

      {showSettings && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-md w-80">
            <h2 className="text-navBg mb-4">Advanced Cookie Settings</h2>

            <div className="mb-4">
              <div className="flex justify-between items-center mb-2">
                <div className="flex flex-col">
                  <span>Essential Cookies</span>
                  <p className="text-gray-600 text-xs">
                    These cookies enable core functionality such as security,
                    verification of identity, and network management. These
                    cookies can't be disabled.
                  </p>
                </div>
                <Switch
                  onChange={() => {}}
                  checked={true}
                  disabled
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={22}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                />
              </div>
            </div>

            <div className="mb-4">
              <div className="flex justify-between items-center mb-2">
                <div className="flex flex-col">
                  <span>Marketing Cookies</span>
                  <p className="text-gray-600 text-xs">
                    These cookies are used to track advertising effectiveness to
                    provide a more relevant service and deliver better ads to
                    suit your interests.
                  </p>
                </div>
                <Switch
                  onChange={() => toggleSetting("marketing")}
                  checked={cookiesConfig.marketing}
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={22}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                />
              </div>
            </div>

            <div className="mb-4">
              <div className="flex justify-between items-center mb-2">
                <div className="flex flex-col">
                  <span>Functional Cookies</span>
                </div>
                <Switch
                  onChange={() => toggleSetting("functional")}
                  checked={cookiesConfig.functional}
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={22}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                />
              </div>
            </div>

            <button
              onClick={handleSaveSettings}
              className="bg-navBg text-white w-full py-2 mt-4"
            >
              Save
            </button>
          </div>
        </div>
      )}

      <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
    </>
  );
};

export default Cookies;
